import { styled } from 'stitches.config'
import { Collapsible } from 'components/Collapsible'
import CSS from 'csstype'

export const MenuTrigger = styled(Collapsible.Trigger, {
  border: 'none',
  padding: '$1 $2',
  color: '$accent-black',

  '& svg': {
    display: 'none',
  },

  '@bp2': {
    borderBottom: '1px solid',
    borderRadius: 0,
    px: '$3',
    fontWeight: '$semiBold',
    fontSize: '$headline',
    lineHeight: '$headline',
    transition: 'border 0.3s ease-out',

    '& svg': {
      display: 'block',
    },
  },

  variants: {
    active: {
      true: {
        backgroundColor: '$primary-700',
        color: '$accent-white',
        borderRadius: '12px 12px 0px 0px',
      },
    },
  },
})

export const MenuContent = styled(Collapsible.Content, {
  color: '$accent-black',
  padding: '$2 $3',
  backgroundColor: '$accent-white',
  borderBottomLeftRadius: '12px',
  borderBottomRightRadius: '12px',
})

export const CollapsibleMenuRoot = styled(Collapsible.Root, {
  backgroundColor: '$accent-white',
  border: '1px solid $tertiary-1000',
  borderRadius: '12px',
})

export const LinkItem = styled('li', {
  border: '1px solid transparent',
  textAlign: 'center',
  padding: '$1 0',
  borderRadius: '4px',
  variants: {
    active: {
      true: {
        backgroundColor: '$primary-700',
        color: '$accent-white',
      },
      false: {
        border: '1px solid $accent-black',
        '&:hover': {
          border: '1px solid $accent-black',
          backgroundColor: '$tertiary-200',
        },
      },
    },
  },
  '&:hover': {
    cursor: 'pointer',
  },
})
